function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Object, String) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          [`${$attr(`theme`)}-theme`]: true,
        }, {
          'banner-wrapper': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'type-indicator': true
          },
        }));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": Object.assign({}, {
            [`${$attr(`size`)}-size`]: true,
          }, {
            'banner-panel': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($helpers.getIcon()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": {
                icon: $helpers.getIcon(),
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'banner-content': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'banner-copy': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(($attr(`header-text`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("header", {
                  "class": {
                    'banner-header': true
                  },
                }, [__vjadeSafeCode($attr(`header-text`))]));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(($attr(`body-text`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat($helpers.formatText($attr(`body-text`), {
                  className: 'banner-body'
                }));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(($attr(`cta`)) ? ((function() {
              var __jade_nodes = [];
              const cta = $attr(`cta`);
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'banner-actions': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": {
                    theme: cta.theme || `secondary`,
                    icon: cta.icon
                  },
                  "on": {
                    click: ev => $helpers.handleCtaButtonClick(cta.actionName, cta.value)
                  },
                }, [__vjadeSafeCode((cta.autoDismiss && !cta.text) ? `Dismiss` : cta.text)]));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;